module.exports = __webpack_public_path__ + "img/8138345.png";